import React from 'react';
import { Text, Preset, Tag, FunctionColor } from '@lux/text';
import { Translate } from '@pegasus/translation';
import * as S from './reserved-popover.styles';
export var ReservedPopover = function (_a) {
    var handleClick = _a.handleClick;
    return (React.createElement(S.ReservedWrapperPopover, null,
        React.createElement(S.ReservedArticlePopover, null,
            React.createElement(S.ReservedArticleHeadline, { preset: Preset.M, color: FunctionColor.function100, bold: true, tag: Tag.DIV },
                React.createElement(Translate, { message: "article.reservedPopoverHeadline" })),
            React.createElement(S.ReservedArticleBody, { preset: Preset.S, color: FunctionColor.function100, tag: Tag.DIV },
                React.createElement(Translate, { message: "article.reservedPopoverFirstLine" })),
            React.createElement(S.ReservedArticleBody, { preset: Preset.S, color: FunctionColor.function100, tag: Tag.DIV },
                React.createElement(Translate, { message: "article.reservedPopoverSecondLine" })),
            React.createElement(S.ReservedArticleCloseSt, { onClick: handleClick },
                React.createElement(Text, { preset: Preset.S, color: FunctionColor.function100 },
                    React.createElement(Translate, { message: "marketingOverlays.close" }))))));
};
export default ReservedPopover;
